import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import './theme/color.less';
import 'vant/lib/index.css';
import Vant from 'vant';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

// 全局设置 dayjs 为中文，配合 Ant Design Vue 使用
dayjs.locale('zh-cn');

createApp(App).use(createPinia()).use(router).use(Vant).use(Antd).mount('#app');
